import React from "react";
import Button, { ForwardButton } from "~assets/js/components/Button";
import Headline from "~assets/js/components/Typography/Headline";
import i18next from "i18next";
import useViewport from "~/assets/js/Helpers/hooks/useViewport";

export const Banner = () => {
    const { isMobile } = useViewport();

    return (
        <div className="franchise-banner__hero">
            <div className="container" style={{ position: "relative" }}>
                <div className="franchise-banner__hero-CTA">
                    <Headline
                        size={1}
                        className="franchise-banner__hero-CTA-title"
                    >
                        {i18next.t("franchise.banner.hero.title")}
                    </Headline>
                    <p className="franchise-banner__hero-CTA-content">
                        {i18next.t("franchise.banner.hero.content")}
                    </p>
                </div>
                <div className="franchise-banner__hero-buttons">
                    {!isMobile && (
                        <ForwardButton
                            href="/franchise-formular"
                            size="SM"
                            variant="primary"
                            label={i18next.t("franchise.banner.hero.cta")}
                        />
                    )}
                    {isMobile && (
                        <Button
                            href="/franchise-formular"
                            size="SM"
                            variant="tertiary"
                            label={i18next.t("franchise.banner.hero.cta")}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Banner;
